import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Axios from 'axios'

Vue.use(VueI18n)

const messages = window.translations;

const vi18n = new VueI18n({
    locale: 'pl',
    messages,
})

export default vi18n;

// fetch(window.env.serwerURL + window.env.apiLinks.teksts)
//     .then(response => response.json())
//     .then(data => {
//         data.map((tekst) => {
//             messages.pl[tekst.id] = tekst.pl;
//             messages.en[tekst.id] = tekst.en;
//             messages.uk[tekst.id] = tekst.uk;
//             messages.ru[tekst.id] = tekst.ru;
//         });
//     });
Axios({ url: window.env.serwerURL + window.env.apiLinks.teksts })
    .then(response => {
        response.data.map((tekst) => {
            messages.pl[tekst.id] = tekst.pl;
            messages.en[tekst.id] = tekst.en;
            messages.uk[tekst.id] = tekst.uk;
            messages.ru[tekst.id] = tekst.ru;
        });
    });